import { sendCriteoEvent } from '@ma-js-common/criteo-helpers';

import { initializeEstimaPlaceSearch } from '../common/search';

const GA_CATEGORY = 'Cocon Estimation';

export function domReady() {
    const tagging = {
        category: GA_CATEGORY,
        actionPrefix: 'estima:search_form',
        label: 'how_to_estimate:top_estima_stripe',
    };
    initializeEstimaPlaceSearch(tagging);
    sendCriteoEvent({ event: 'viewPage' });
}
